import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { type PaginationID } from '@webapp/core/providers/Pagination/pagination.types'
import { PaginationControlsContext } from '@webapp/core/providers/Pagination/PaginationControlsContext'
import { PaginationPage } from '../../features/update-pagination/presenters/PaginationPage'
import { PaginationPageLimit } from '../../features/update-pagination/presenters/PaginationPageLimit'
import { PaginationSearch } from '../../features/update-pagination/presenters/PaginationSearch'
import { PaginationSort } from '../../features/update-pagination/presenters/PaginationSort'

export interface IPaginationControlsProps {
  id: PaginationID
}

export const PaginationControls = ({
  id,
  children,
}: PropsWithChildren<IPaginationControlsProps>) => {
  const value = useMemo(() => ({ id }), [id])

  return (
    <PaginationControlsContext.Provider value={value}>
      {children}
    </PaginationControlsContext.Provider>
  )
}

PaginationControls.Page = PaginationPage
PaginationControls.Sort = PaginationSort
PaginationControls.Search = PaginationSearch
PaginationControls.PageLimit = PaginationPageLimit
